import { Link } from 'react-router-dom';

import { ROUTE_DECISION } from 'CorePackage/MainModule/routes/routes';
import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';

import styles from './DecisionListIdCell.module.scss';

interface IDecisionListId {
  id: string | number;
}

export function DecisionListIdCell<T extends IDecisionListId>({ value, row, isTest }: Readonly<ITableRenderCell<T>>) {
  return (
    <div className={styles.ErpIdCellWrapper}>
      <Link className="shared-table-link" to={ROUTE_DECISION(row.id)} target="_blank" rel="noopener noreferrer">
        {value}
      </Link>
      {isTest && <span className={styles.TestUserWrapper}>ТЕСТ</span>}
    </div>
  );
}
